var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H7v7a4.5 4.5 0 0 0 4.5 4.5h1A4.5 4.5 0 0 0 17 12V5h-1.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1H18v7a5.5 5.5 0 0 1-5.5 5.5h-1A5.5 5.5 0 0 1 6 12V5H4.5a.5.5 0 0 1-.5-.5M5.5 19a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgTextEditUnderline = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextEditUnderline);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDQuNUM0IDQuMjIzODYgNC4yMjM4NiA0IDQuNSA0SDYuNUg4LjVDOC43NzYxNCA0IDkgNC4yMjM4NiA5IDQuNUM5IDQuNzc2MTQgOC43NzYxNCA1IDguNSA1SDdWMTJDNyAxNC40ODUzIDkuMDE0NzIgMTYuNSAxMS41IDE2LjVIMTIuNUMxNC45ODUzIDE2LjUgMTcgMTQuNDg1MyAxNyAxMlY1SDE1LjVDMTUuMjIzOSA1IDE1IDQuNzc2MTQgMTUgNC41QzE1IDQuMjIzODYgMTUuMjIzOSA0IDE1LjUgNEgxNy41SDE5LjVDMTkuNzc2MSA0IDIwIDQuMjIzODYgMjAgNC41QzIwIDQuNzc2MTQgMTkuNzc2MSA1IDE5LjUgNUgxOFYxMkMxOCAxNS4wMzc2IDE1LjUzNzYgMTcuNSAxMi41IDE3LjVIMTEuNUM4LjQ2MjQzIDE3LjUgNiAxNS4wMzc2IDYgMTJWNUg0LjVDNC4yMjM4NiA1IDQgNC43NzYxNCA0IDQuNVpNNS41IDE5QzUuMjIzODYgMTkgNSAxOS4yMjM5IDUgMTkuNUM1IDE5Ljc3NjEgNS4yMjM4NiAyMCA1LjUgMjBIMTguNUMxOC43NzYxIDIwIDE5IDE5Ljc3NjEgMTkgMTkuNUMxOSAxOS4yMjM5IDE4Ljc3NjEgMTkgMTguNSAxOUg1LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";